import React from "react";
import "./NewsSkeleton.scss";

/*
  Заглушка списка новостей на время запроса. Геометрия повторяет
  NewsBottomCard: картинка 300x300 слева и текстовая колонка справа на
  десктопе, на ≤870 — картинка 16/9 над текстом.

  Смысл не в красоте, а в резерве высоты: до этого список до ответа API был
  пустым, футер стоял сразу под заголовком и при приходе восьми карточек
  улетал вниз — на /news это давало CLS 0.60 (1280) и 0.84 (390), почти
  целиком один сдвиг .footer_container.

  Восьми карточек хватает с запасом: восемь — столько отдаёт API, и уже
  после третьей футер уходит за пределы экрана, поэтому на ≤870 остальные
  прячет css (меньше узлов, резерв тот же по смыслу).
*/
const CARDS = [0, 1, 2, 3, 4, 5, 6, 7];

const NewsSkeleton = () => (
  <div className="newsSkeleton" aria-hidden="true">
    {CARDS.map((i) => (
      <div className="newsSkeleton_card" key={i}>
        <span className="newsSkeleton_img" />
        <div className="newsSkeleton_text">
          <span className="newsSkeleton_bar newsSkeleton_bar--date" />
          <span className="newsSkeleton_bar newsSkeleton_bar--title" />
          <span className="newsSkeleton_bar newsSkeleton_bar--line" />
          <span className="newsSkeleton_bar newsSkeleton_bar--line" />
          <span className="newsSkeleton_bar newsSkeleton_bar--line newsSkeleton_bar--short" />
        </div>
      </div>
    ))}
  </div>
);

export default NewsSkeleton;
